export default {
    subscribe: null,
    roomIds: [],
    rooms: [],
    roomMessages: []
};
